import React from 'react';
import { searchAttributes } from '@neptune/shared/leaderboard-domain';
import { AttributeDefinition, AttributeType } from 'domain/experiment/attribute';
import { unwindSubpropertyStrategies, UnwindSubpropertyStrategy } from './unwind-property-strategy';

type UseAttributeDefinitionQueryProps = {
  limit?: number;
  projectIdentifier: string;
  subpropertyStrategy: UnwindSubpropertyStrategy;
  types: string[];
  query: string;
};

export const useAttributeDefinitionQuery = ({
  limit,
  projectIdentifier,
  subpropertyStrategy,
  types,
  query,
}: UseAttributeDefinitionQueryProps): ((
  search: string,
  filterAttributeTypes?: AttributeType[],
) => Promise<AttributeDefinition[]>) => {
  return React.useCallback(
    async (search: string, filterAttributeTypes?: AttributeType[]) => {
      const input = await searchAttributes({
        limit,
        projectIdentifier,
        query,
        search,
        type: types,
        filterAttributeTypes,
      });
      return unwindSubpropertyStrategies[subpropertyStrategy](input);
    },
    [limit, projectIdentifier, subpropertyStrategy, types, query],
  );
};
